const initialLoginExpiredState = false;

const loadLoginExpiredState = () => {
  try {
    const fetchedLoginExpiredState =
      sessionStorage.getItem('loginExpiredState');

    if (fetchedLoginExpiredState === null) {
      return initialLoginExpiredState;
      // eslint-disable-next-line no-else-return
    } else {
      return JSON.parse(fetchedLoginExpiredState);
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('Load of loginExpiredState from sessionStorage failed.');
    return initialLoginExpiredState;
  }
};

export const saveLoginExpiredState = (loginExpiredState) => {
  try {
    sessionStorage.setItem(
      'loginExpiredState',
      JSON.stringify(loginExpiredState)
    );
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('Save of loginExpiredState to sessionStorage failed.');
  }
};

export const loginExpired = () => {
  return loadLoginExpiredState();
};

const initialTAndCState = {
  acceptedTAndCTimestamp: 0,
};

const loadTAndCState = () => {
  try {
    const serializedTAndCState = sessionStorage.getItem('tAndCState');

    if (serializedTAndCState === null) {
      return initialTAndCState;
      // eslint-disable-next-line no-else-return
    } else {
      return JSON.parse(serializedTAndCState).tAndCState;
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('Load of tAndCState from sessionStorage failed.');
    return initialTAndCState;
  }
};

export const saveTAndCState = () => {
  try {
    const sessionStorageTAndCState = initialTAndCState;
    sessionStorageTAndCState.acceptedTAndCTimestamp = Date.now();

    const serializedTAndCState = '{"tAndCState":'.concat(
      JSON.stringify(sessionStorageTAndCState),
      '}'
    );
    sessionStorage.setItem('tAndCState', serializedTAndCState);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('Save of tAndCState to sessionStorage failed.');
  }
};

export const tAndCAcceptedRecently = () => {
  const lastAgreeTimestamp = loadTAndCState().acceptedTAndCTimestamp;
  const secondsSinceLastAgree = (Date.now() - lastAgreeTimestamp) / 1000;
  // Currently "Recently" means 5 minutes (5min*60sec=300seconds)
  return secondsSinceLastAgree < 300;
};

const initialRedirectedFromAuthPageState = false;

const loadRedirectedFromAuthPageState = () => {
  try {
    const fetchedRedirectedFromAuthPageState = sessionStorage.getItem(
      'redirectedFromAuthPageState'
    );

    if (fetchedRedirectedFromAuthPageState === null) {
      return initialRedirectedFromAuthPageState;
      // eslint-disable-next-line no-else-return
    } else {
      return JSON.parse(fetchedRedirectedFromAuthPageState);
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(
      'Load of redirectedFromAuthPageState from sessionStorage failed.'
    );
    return initialRedirectedFromAuthPageState;
  }
};

export const saveRedirectedFromAuthPageState = (
  redirectedFromAuthPageState
) => {
  try {
    sessionStorage.setItem(
      'redirectedFromAuthPageState',
      JSON.stringify(redirectedFromAuthPageState)
    );
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(
      'Save of redirectedFromAuthPageState to sessionStorage failed.'
    );
  }
};

export const redirectedFromAuthPage = () => {
  return loadRedirectedFromAuthPageState();
};
